module.exports = __webpack_public_path__ + "static/media/combined-shape.31507d98.svg";